import type { IQuizRepository } from '@/core/domain/quiz/IQuizRepository.ts'
import type { Quiz } from '@/core/domain/quiz/Quiz.ts'
import type { QuizQuestion } from '@/core/domain/quiz/QuizQuestion.ts'

export class UpdateQuizQuestionsUseCase {
  private quizRepository: IQuizRepository

  constructor(quizRepository: IQuizRepository) {
    this.quizRepository = quizRepository
  }

  async execute(quizId: number, questions: QuizQuestion[]): Promise<Quiz> {
    return await this.quizRepository.updateQuiz(quizId, questions)
  }
}
